export default {
  "wrapper": "_wrapper_z3bcj8"
};